/**
 * 获取本周、本季度、本月、上月的开始日期、结束日期
 */
var now = new Date() // 当前日期
var nowDayOfWeek = now.getDay() // 今天本周的第几天
var nowDay = now.getDate() // 当前日
var nowMonth = now.getMonth() // 当前月
var nowYear = now.getYear() // 当前年
nowYear += nowYear < 2000 ? 1900 : 0
var lastMonthDate = new Date() // 上月日期
lastMonthDate.setDate(1)
lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)
// var lastYear = lastMonthDate.getYear();
var lastMonth = lastMonthDate.getMonth()
// 格式化日期：yyyy-MM-dd
function formatDate(date, str = '-') {
  var myyear = date.getFullYear()
  var mymonth = date.getMonth() + 1
  var myweekday = date.getDate()
  if (mymonth < 10) {
    mymonth = '0' + mymonth
  }
  if (myweekday < 10) {
    myweekday = '0' + myweekday
  }
  return myyear + str + mymonth + str + myweekday
}
//获取完整的日期 yyyy-MM-dd HH:MM:SS
function getFullTimeStr(date) {
  date = new Date(date)
  var YY = date.getFullYear() + '-'
  var MM =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-'
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hh =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
  var mm =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
  var ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  return YY + MM + DD + ' ' + hh + mm + ss
}
//获取完整的日期 yyyy-MM-dd HH:MM:SS
function getShortFullTimeStr(date) {
  date = new Date(date)
  var YY = date.getFullYear() + ''
  var MM =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + ''
  var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate() + ''
  var hh = date.getHours() < 10 ? '0' + date.getHours() : date.getHours() + ''
  var mm =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes() + ''
  var ss =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds() + ''
  return YY + MM + DD + hh + mm + ss
}
// 获得某月的天数
function getMonthDays(myMonth) {
  var monthStartDate = new Date(nowYear, myMonth, 1)
  var monthEndDate = new Date(nowYear, myMonth + 1, 1)
  var days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
  return days
}
// 获得本季度的开始月份
function getQuarterStartMonth() {
  var quarterStartMonth = 0
  if (nowMonth < 3) {
    quarterStartMonth = 0
  }
  if (nowMonth > 2 && nowMonth < 6) {
    quarterStartMonth = 3
  }
  if (nowMonth > 5 && nowMonth < 9) {
    quarterStartMonth = 6
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9
  }
  return quarterStartMonth
}
// 获得本周的开始日期: woniu6162-自定义(星期一为第一天)
function getWeekStartDate() {
  if (nowDayOfWeek === '0') {
    let weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 6)
    return formatDate(weekStartDate)
  } else {
    let weekStartDate = new Date(nowYear, nowMonth, nowDay + (1 - nowDayOfWeek))
    return formatDate(weekStartDate)
  }
}
// 获得本周的结束日期
function getWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay + (6 - nowDayOfWeek))
  return formatDate(weekEndDate)
}
// 获得上周的开始日期
function getLastWeekStartDate() {
  var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 7)
  return formatDate(weekStartDate)
}
// 获得上周的结束日期
function getLastWeekEndDate() {
  var weekEndDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek - 1)
  return formatDate(weekEndDate)
}
// 获得本月的开始日期
function getMonthStartDate() {
  var monthStartDate = new Date(nowYear, nowMonth, 1)
  return formatDate(monthStartDate)
}
// 获得本月的结束日期
function getMonthEndDate() {
  var monthEndDate = new Date(nowYear, nowMonth, getMonthDays(nowMonth))
  return formatDate(monthEndDate)
}
// 获得上月开始时间
function getLastMonthStartDate() {
  var lastMonthStartDate = new Date(nowYear, lastMonth, 1)
  return formatDate(lastMonthStartDate)
}
// 获得上月结束时间
function getLastMonthEndDate() {
  var lastMonthEndDate = new Date(nowYear, lastMonth, getMonthDays(lastMonth))
  return formatDate(lastMonthEndDate)
}
// 获得本季度的开始日期
function getQuarterStartDate() {
  var quarterStartDate = new Date(nowYear, getQuarterStartMonth(), 1)
  return formatDate(quarterStartDate)
}
// 或的本季度的结束日期
function getQuarterEndDate() {
  var quarterEndMonth = getQuarterStartMonth() + 2
  var quarterStartDate = new Date(
    nowYear,
    quarterEndMonth,
    getMonthDays(quarterEndMonth)
  )
  return formatDate(quarterStartDate)
}

// n天前的时间
function dayAfterThreeFn(day, time) {
  let today = new Date()
  let targetDay = today.getTime() + 1000 * 60 * 60 * 24 * day
  today.setTime(targetDay)

  let tYear = today.getFullYear()
  let tMonth = today.getMonth()
  let tDate = today.getDate()
  let tHour = today.getHours()
  let tMin = today.getMinutes()
  let tSeconds = today.getSeconds()
  tMonth = this.handleDate(tMonth + 1)
  tDate = this.handleDate(tDate)
  tHour = this.handleDate(tHour)
  tMin = this.handleDate(tMin)
  tSeconds = this.handleDate(tSeconds)
  if (time === 'now') {
    return (
      tYear +
      '-' +
      tMonth +
      '-' +
      tDate +
      ' ' +
      tHour +
      ':' +
      tMin +
      ':' +
      tSeconds
    )
  } else {
    return tYear + '-' + tMonth + '-' + tDate + ' 00:00:00'
  }
}

// 获取当前天距离某个时间多少天
function getDistanceDay(date1, date2, flag = 0) {
  // parse() 是 Date 的一个静态方法 , 所以应该使用 Date.parse() 来调用，而不是作为 Date 的实例方法。返回该日期距离 1970/1/1 午夜时间的毫秒数
  if (date1 === 'now') {
    date1 = new Date().getTime()
  } else {
    date1 = Date.parse(date1.replace(/-/g, '/'))
  }
  date2 = flag ? date2 : Date.parse(date2.replace(/-/g, '/'))
  if (date2 - date1 <= 0) {
    return 0
  }
  // 计算两个日期之间相差的毫秒数的绝对值
  var distance = Math.abs(date2 - date1)

  // 毫秒数除以一天的毫秒数,就得到了天数
  var days = Math.floor(distance / (24 * 3600 * 1000))

  var leave1 = distance % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = handleDate(Math.floor(leave1 / (3600 * 1000)))
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = handleDate(Math.floor(leave2 / (60 * 1000)))
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = handleDate(Math.round(leave3 / 1000))
  return [days, hours, minutes, seconds]
}

// 封装函数(data格式为2017-11-11)
function formatTimeStamp(date, time = '0:0:0') {
  return (
    Date.parse(new Date(`${date} ${time}`)) ||
    Date.parse(new Date(`${date.replace(/-/g, '/')} ${time}`))
  )
}

/**
 * 两个时间相距 取时间格式 00天00时00分
 */
function getDistanceTime(date1, date2) {
  if (date1 === 'now') {
    date1 = new Date().getTime()
  } else {
    date1 = Date.parse(date1.replace(/-/g, '/'))
  }
  date2 = Date.parse(date2.replace(/-/g, '/'))
  // 计算两个日期之间相差的毫秒数的绝对值
  // var distance = Math.abs(date2 - date1);
  var distance = date2 - date1
  distance = distance > 0 ? distance : 0
  var days = Math.floor(distance / (24 * 3600 * 1000))
  var leave1 = distance % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = handleDate(Math.floor(leave1 / (3600 * 1000)))
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = handleDate(Math.floor(leave2 / (60 * 1000)))
  return `${days}天${hours}小时${minutes}分`
}

// 处理月/日的显示格式
function handleDate(date) {
  // var d =date;
  // if (date.toString().length === 1) {
  //   d = "0" + date;
  // }
  // return d;
  return ('00' + date).slice(String(date).length)
}
//是不是今天
function isToday(date) {
  let year = date.getFullYear()
  let month = date.getMonth()
  let day = date.getDate()
  let now = new Date()
  let curYear = now.getFullYear()
  let curMonth = now.getMonth()
  let curDay = now.getDate()
  return curYear == year && curMonth == month && curDay == day
}
//是不是昨天
function isYearstoday(date) {
  let now = new Date().getTime()
  let yearstodayTime = now - 24 * 60 * 60 * 1000
  let yearstodayDate = new Date(yearstodayTime)
  return (
    yearstodayDate.getFullYear() == date.getFullYear() &&
    yearstodayDate.getMonth() == date.getMonth() &&
    yearstodayDate.getDate() == date.getDate()
  )
}
//是不是今年
function isThisYear(date) {
  let year = date.getFullYear()
  let curYear = new Date().getFullYear()
  return year == curYear
}
//自动补0
function addZero(num) {
  return num > 9 ? num : '0' + num
}
function handleCommentDate(date) {
  if (isToday(date)) {
    return '今天 ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes())
  } else if (isYearstoday(date)) {
    return '昨天 ' + addZero(date.getHours()) + ':' + addZero(date.getMinutes())
  } else if (isThisYear(date)) {
    return (
      addZero(date.getMonth() + 1) +
      '.' +
      addZero(date.getDate()) +
      ' ' +
      addZero(date.getHours()) +
      ':' +
      addZero(date.getMinutes())
    )
  } else {
    return (
      date.getFullYear() +
      '.' +
      addZero(date.getMonth() + 1) +
      '.' +
      addZero(date.getDate()) +
      ' ' +
      addZero(date.getHours()) +
      ':' +
      addZero(date.getMinutes())
    )
  }
}
export default {
  formatDate,
  getFullTimeStr,
  formatTimeStamp,
  getMonthDays,
  getQuarterStartMonth,
  getWeekStartDate,
  getWeekEndDate,
  getLastWeekStartDate,
  getLastWeekEndDate,
  getMonthStartDate,
  getMonthEndDate,
  getLastMonthStartDate,
  getLastMonthEndDate,
  getQuarterStartDate,
  getQuarterEndDate,
  getDistanceDay,
  dayAfterThreeFn,
  handleDate,
  getDistanceTime,
  getShortFullTimeStr,
  handleCommentDate,
  isToday
}
